import React, { useState } from "react";
import { Col, Card, Row, Modal, Button } from "react-bootstrap";
import { FaTimes, FaTrash } from "react-icons/fa"; // Import cross icon
import "./ProductComponent.css"; // Optional CSS for custom styles


const ProductComponent = ({ product, onDelete }) => {
  const [showModal, setShowModal] = useState(false);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

 

  return (
    <>
      <Col xs={12} md={4} lg={5} className="mb-4 border rounded p-3  mx-3">
      <div className="d-flex justify-content-end">
    <FaTrash
      className="delete-icon mb-2"
      style={{ cursor: "pointer", color: "red"}}
      onClick={onDelete}
    />
  </div>
        <Row className=" align-items-center position-relative ">
          {/* Cross Icon to Delete */}
         

          <Col xs={5}>
            <Card.Img
              // variant="top"
              src={
                /\.(jpg|jpeg|png|gif)$/i.test(product.product_image)
                  ? product.product_image
                  : "https://bagh-e-upload-files-to-s3.s3.eu-west-1.amazonaws.com/profile_image/1731576285400_0753e1c58aec1719e5eef4385983cc79.png"
              } 
              alt={product.productName}
              className="product-image"
            />
          </Col>

          {/* Product Details (right side) */}
          <Col xs={7}>
            <Card.Body>
              <Card.Text>
                <strong>Crop:</strong> {product.productName}
              </Card.Text>
              <Card.Text>
  {product.requiredQuantity ? (
    <>
      <strong>Quantity:</strong> {product.requiredQuantity}
    </>
  ) : (
    <>
    <strong>Quantity:</strong> Task not assigned
    </>
  )}
</Card.Text>

<Card.Text>
  {product.earliestDueDate && !isNaN(new Date(product.earliestDueDate).getTime()) ? (
    <>
      <strong>Date:</strong> {new Date(product.earliestDueDate).toLocaleDateString('en-US')}
    </>
  ) : (
    <>
    <strong>Date:</strong> Task not assigned
    </>
  )}
</Card.Text>


              <Card.Text>
                <strong>Area:</strong>{" "}
                {product?.region?.map((r) => r.region).join(", ")}
              </Card.Text>
              <Card.Text>
                <strong>Price:</strong>{" "}
                {product?.amount}
              </Card.Text>
              <Card.Text>
                <strong>Unit:</strong>{" "}
                {product?.unit}
              </Card.Text>
            </Card.Body>
          </Col>
        </Row>
      </Col>

      {/* Delete Confirmation Modal */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the product <strong>{product.productName}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button variant="danger" >
            Yes, Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ProductComponent;
